<template>
  <div class="row mt-4" v-if="devoluciones.total > 0">
    <div class="col-12">
      <div class="card ficha-listado">
        <div class="px-4 pb-4 card-body">

          <div class="mb-3">
            <h6 class="mb-0 panel-section-title">Devoluciones y reembolsos</h6>
            <p class="text-xs opacity-7 mb-0">Pedidos completados que fueron reembolsados vía Stripe</p>
          </div>

          <!-- KPIs -->
          <div class="row g-2 mb-4">
            <div class="col-6 col-md-3">
              <div class="dev-kpi">
                <div class="dev-kpi__k">Total devueltos</div>
                <div class="dev-kpi__v dev-kpi__v--rojo">{{ devoluciones.total }}</div>
                <div class="dev-kpi__sub">pedidos</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="dev-kpi">
                <div class="dev-kpi__k">Importe devuelto</div>
                <div class="dev-kpi__v dev-kpi__v--rojo">{{ fmtEur(devoluciones.importe) }}</div>
                <div class="dev-kpi__sub">reembolsado</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="dev-kpi">
                <div class="dev-kpi__k">Tasa sobre ventas</div>
                <div class="dev-kpi__v" :class="devoluciones.tasa_unidades > 10 ? 'dev-kpi__v--rojo' : 'dev-kpi__v--naranja'">
                  {{ devoluciones.tasa_unidades }}%
                </div>
                <div class="dev-kpi__sub">sobre pedidos completados</div>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="dev-kpi">
                <div class="dev-kpi__k">Tasa sobre ingresos</div>
                <div class="dev-kpi__v" :class="devoluciones.tasa_importe > 10 ? 'dev-kpi__v--rojo' : 'dev-kpi__v--naranja'">
                  {{ devoluciones.tasa_importe }}%
                </div>
                <div class="dev-kpi__sub">del total facturado</div>
              </div>
            </div>
          </div>

          <div class="row g-3">
            <!-- Por motivo -->
            <div class="col-12 col-md-5">
              <p class="text-xs fw-bold text-uppercase opacity-7 mb-2">Por motivo</p>
              <div class="dev-motivos">
                <div v-for="m in devoluciones.por_motivo" :key="m.motivo" class="dev-motivo-row">
                  <div class="dev-motivo-row__label">
                    <span class="dev-motivo-row__badge" :class="motivoClass(m.motivo)">{{ motivoLabel(m.motivo) }}</span>
                  </div>
                  <div class="dev-motivo-row__bar-wrap">
                    <div class="dev-motivo-row__bar" :style="{ width: motivoWidth(m.total) }"></div>
                  </div>
                  <span class="dev-motivo-row__val">{{ m.total }}</span>
                  <span class="dev-motivo-row__eur">{{ fmtEur(m.importe) }}</span>
                </div>
              </div>
            </div>

            <!-- Por mes -->
            <div class="col-12 col-md-7" v-if="devoluciones.por_mes.length > 1">
              <p class="text-xs fw-bold text-uppercase opacity-7 mb-2">Evolución mensual</p>
              <div class="table-responsive">
              <table class="table table-sm dev-table">
                <thead>
                  <tr>
                    <th>Mes</th>
                    <th class="text-end">Devoluciones</th>
                    <th class="text-end">Importe</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="r in devoluciones.por_mes" :key="r.mes">
                    <td>{{ fmtMes(r.mes) }}</td>
                    <td class="text-end">{{ r.total }}</td>
                    <td class="text-end text-danger">{{ fmtEur(r.importe) }}</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>
            <div class="col-12 col-md-7" v-else-if="devoluciones.por_mes.length === 1">
              <p class="text-xs fw-bold text-uppercase opacity-7 mb-2">Período</p>
              <p class="text-sm mb-0">
                Todas las devoluciones ocurrieron en <strong>{{ fmtMes(devoluciones.por_mes[0].mes) }}</strong>.
              </p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
const MESES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
function fmtMes(s) {
  if (!s) return s;
  const [y, m] = s.split("-");
  return `${MESES[parseInt(m) - 1]} '${String(y).slice(2)}`;
}

const MOTIVO_LABELS = {
  requested_by_customer: "A petición del cliente",
  duplicate:             "Duplicado",
  fraudulent:            "Fraude",
  otro:                  "Otro",
};
const MOTIVO_CLASS = {
  requested_by_customer: "badge-naranja",
  duplicate:             "badge-azul",
  fraudulent:            "badge-rojo",
  otro:                  "badge-gris",
};

export default {
  name: "PanelTipsterDevoluciones2",
  props: {
    devoluciones: {
      type: Object,
      default: () => ({ total: 0, importe: 0, tasa_unidades: 0, tasa_importe: 0, por_motivo: [], por_mes: [] }),
    },
  },
  computed: {
    maxMotivo() {
      return Math.max(...(this.devoluciones.por_motivo || []).map(m => m.total), 1);
    },
  },
  methods: {
    fmtEur(n) {
      return Number(n || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" });
    },
    fmtMes,
    motivoLabel(m) { return MOTIVO_LABELS[m] || m; },
    motivoClass(m) { return MOTIVO_CLASS[m] || "badge-gris"; },
    motivoWidth(v) { return `${Math.max((v / this.maxMotivo) * 100, 8)}%`; },
  },
};
</script>

<style scoped>
.dev-kpi {
  background: var(--q-card-alt);
  border: 1px solid var(--q-border);
  border-radius: 12px;
  padding: 12px 14px;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 2px;
}
.dev-kpi__k {
  font-size: 11px;
  color: var(--q-muted);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .4px;
}
.dev-kpi__v {
  font-size: 20px;
  font-weight: 800;
  line-height: 1.1;
  color: var(--q-text);
}
.dev-kpi__v--rojo    { color: var(--q-red); }
.dev-kpi__v--naranja { color: var(--q-amber); }
.dev-kpi__sub { font-size: 10px; color: var(--q-muted); }

/* Motivos */
.dev-motivos { display: flex; flex-direction: column; gap: 10px; }
.dev-motivo-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.dev-motivo-row__label { min-width: 120px; }
.dev-motivo-row__badge {
  font-size: 11px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 20px;
  white-space: nowrap;
}
.badge-naranja { background: var(--q-amber-soft); color: var(--q-amber); }
.badge-azul    { background: var(--q-hover); color: var(--q-gold); }
.badge-rojo    { background: var(--q-red-soft); color: var(--q-red); }
.badge-gris    { background: var(--q-hover); color: var(--q-muted); }

.dev-motivo-row__bar-wrap {
  flex: 1;
  background: var(--q-hover);
  border-radius: 6px;
  height: 8px;
  overflow: hidden;
}
.dev-motivo-row__bar {
  height: 100%;
  background: linear-gradient(90deg, var(--q-red), rgba(255, 89, 100, 0.35));
  border-radius: 6px;
  transition: width .3s ease;
}
.dev-motivo-row__val {
  font-size: 12px;
  font-weight: 700;
  color: var(--q-text);
  min-width: 20px;
  text-align: right;
}
.dev-motivo-row__eur {
  font-size: 11px;
  color: var(--q-muted);
  min-width: 70px;
  text-align: right;
}

/* Tabla */
.dev-table { font-size: 12px; border-collapse: collapse; }
.dev-table th,
.dev-table td { border: none !important; box-shadow: none !important; }
.dev-table thead th {
  font-size: 10px; text-transform: uppercase; color: var(--q-muted);
  font-weight: 600; border-bottom: 1px solid var(--q-border) !important; padding: 4px 6px;
}
.dev-table tbody td { padding: 5px 6px; color: var(--q-text); border-bottom: 1px solid var(--q-border) !important; }
</style>
